import { createQueryKeyStore } from '@lukemorales/query-key-factory'

export const keys = createQueryKeyStore({
  account: {
    details: null,
  },
  destinations: {
    all: null,
    details: (destinationId: string) => [destinationId],
  },
  home: {
    details: (isAuthenticated: boolean) => [{ isAuthenticated }],
  },
  rooms: {
    details: (destinationId: string, roomId: string) => [destinationId, roomId],
  },
  services: {
    all: (destinationId: string) => [destinationId],
    details: (destinationId: string, serviceId: string) => [destinationId, serviceId],
  },
})
